import { OverlayTrigger, Tooltip } from "react-bootstrap";

const TooltipTitle = ({ title, placement = "top", children }) => {
  return (
    <OverlayTrigger placement={placement} overlay={<Tooltip className="IRANSans">{title}</Tooltip>}>
      {children}
    </OverlayTrigger>
  );
};

export default TooltipTitle;
